import { Component, OnInit } from '@angular/core';
import { IDoesFilterPassParams } from 'ag-grid-community';
import moment from 'moment';
import { YEARS_LIMIT } from '../../../utils/value-getters/structure';
import { BaseSliderFilterComponent } from '../base-slider-filter.component';

const MAX_YEAR = moment().year() + YEARS_LIMIT;

const valueFormatter = (value: number): string =>
  value === MAX_YEAR ? `${value}+` : value.toString();

@Component({
  selector: 'muni-shared-structure-filter',
  templateUrl: './structure-filter.component.html',
  styleUrls: ['./structure-filter.component.scss']
})
export class StructureFilterComponent
  extends BaseSliderFilterComponent
  implements OnInit {
  constructor() {
    super();
  }

  ngOnInit(): void {
    this.minValue = moment().year();
    this.maxValue = MAX_YEAR;
    this.sliderOptions = {
      floor: moment().year(),
      animate: false,
      ceil: MAX_YEAR,
      step: 1,
      vertical: true,
      showTicksValues: true,
      rightToLeft: true,
      ticksArray: [moment().year() + 10, moment().year() + 20],
      translate: valueFormatter,
      combineLabels: (minValue: string, maxValue: string): string => {
        if (maxValue === minValue) {
          return `${maxValue}`;
        } else if (minValue === valueFormatter(MAX_YEAR)) {
          return `${maxValue}+`;
        } else {
          return `${maxValue} - ${minValue}`;
        }
      }
    };
  }

  public doesFilterPass(params: IDoesFilterPassParams): boolean {
    // just a stub, look for advancedFiltersPass
    return true;
  }

  public getModelAsString(): string {
    if (this.isFilterActive()) {
      if (this.minValue === this.maxValue) {
        return valueFormatter(this.minValue);
      } else if (this.maxValue === MAX_YEAR) {
        return `${valueFormatter(this.minValue)}+`;
      } else {
        return `${valueFormatter(this.minValue)} - ${valueFormatter(
          this.maxValue
        )}`;
      }
    } else {
      return '';
    }
  }

  public setOptions(year: number) {
    const floor = year;
    const ceil = year + YEARS_LIMIT;

    this.sliderOptions = {
      ...this.sliderOptions,
      floor,
      ceil,
      ticksArray: [floor + 5, floor + 10, floor + 15, floor + 20, floor + 25]
    };

    this.minValue = floor;
    this.maxValue = ceil;
  }
}
